export const Etapas = [
    {id: 1, name:'Identificación y definición de problemas públicos'},
    {id: 2, name:'Diseño de intervenciones públicas'},
    {id: 3, name:'Implementación'},
    {id: 4, name:'Monitoreo y seguimiento'},
    {id: 5, name:'Evaluación'},

];
